import Homepage from "../../views/Homepage";

export default [
  {
    path: "/",
    component: Homepage,
    meta: {
      title: "Home Page - 1byone Health"
    }
  }
]